import { Route, Switch } from "wouter";
import Login from "../pages/auth/Login";
import CfxreCallback from "../pages/auth/CfxreCallback";
import AddMasterPin from "../pages/auth/AddMasterPin";
import AddMasterCallback from "../pages/auth/AddMasterCallback";
import Wordmark from "@/components/Wordmark";
import { useThemedImage } from "@/hooks/theme";
import { handleExternalLinkClick } from "@/lib/navigation";
import { AuthError } from "@/pages/auth/errors";
import DynamicAdvert from "@/components/DynamicAdvert";
import { ShieldCheckIcon } from "lucide-react";

function AuthContentWrapper({ children }: { children: React.ReactNode }) {
    return (
        <div className="fc-auth-body text-center">
            {children}
        </div>
    );
}


export default function AuthShell() {
    const customLogoUrl = useThemedImage(window.txConsts.providerLogo);
    return (
        <div className="fc-auth pattern-dots">
            <div className="fc-auth-column">
                <section className="fc-auth-panel">
                    <span className="fc-panel-accent" />
                    <span className="fc-panel-stripes" />
                    <span className="fc-panel-stripes flip" />
                    <span className="fc-panel-corner tl" />
                    <span className="fc-panel-corner br" />
                    <ShieldCheckIcon className="fc-panel-watermark" strokeWidth={1.2} aria-hidden="true" />
                    <header className="fc-auth-head">
                        <div className="fc-brand-lockup">
                            <Wordmark />
                            <div className="fc-brand-copy"><strong>FC ADMIN</strong></div>
                        </div>
                        {customLogoUrl ? (
                            <img
                                className="fc-auth-provider"
                                src={customLogoUrl}
                                alt={window.txConsts.providerName}
                            />
                        ) : null}
                    </header>
                    <Switch>
                        <Route path="/login">
                            <Login />
                        </Route>
                        <Route path="/login/callback">
                            <AuthContentWrapper>
                                <CfxreCallback />
                            </AuthContentWrapper>
                        </Route>
                        <Route path="/addMaster/pin">
                            <AuthContentWrapper>
                                <AddMasterPin />
                            </AuthContentWrapper>
                        </Route>
                        <Route path="/addMaster/callback">
                            <AuthContentWrapper>
                                <AddMasterCallback />
                            </AuthContentWrapper>
                        </Route>
                        <Route path="/:fullPath*">
                            <AuthContentWrapper>
                                <AuthError
                                    error={{
                                        errorTitle: '404 | Nicht gefunden',
                                        errorMessage: 'Diese Seite existiert nicht.',
                                    }}
                                />
                            </AuthContentWrapper>
                        </Route>
                    </Switch>
                </section>

                <div className="fc-auth-partners">
                    <DynamicAdvert placement='login' />
                    <a
                        href='https://discord.gg/uAmsGa2'
                        onClick={handleExternalLinkClick}
                        target='_blank'
                        className='fc-auth-partner'
                    >
                        <img src="img/discord.png" alt="Discord" />
                    </a>
                </div>

                <div className="fc-auth-footer">
                    FC Admin · Core <strong>v{window.txConsts.txaVersion}</strong> · FXServer <strong>b{window.txConsts.fxsVersion}</strong>
                </div>
            </div>
        </div>
    );
}
